import Card from 'react-bootstrap/Card';
import StyledTableCell from '../../../../components/StyledTableCell';
import { Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';

function DashboardFunnel({ funnelReport }) {
  return (
    <Card className="mb-3">
      <Card.Header className="d-flex justify-content-between">Signup Funnel Summary</Card.Header>
      <Card.Body className="bo-min-h-100">
        {funnelReport && (
          <TableContainer>
            <Table aria-labelledby="tableTitle" aria-label="enhanced table">
              <TableHead>
                <TableRow>
                  <StyledTableCell align="left" />
                  <StyledTableCell align="center">Opened Link</StyledTableCell>
                  <StyledTableCell align="center">Consumer Created</StyledTableCell>
                  <StyledTableCell align="center">Bank Account Linked</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {[
                  ['Today', 'today'],
                  ['Yesterday', 'yesterday'],
                  ['This Week', 'thisWeek'],
                  ['This Month', 'thisMonth'],
                  ['This Year', 'thisYear'],
                  ['Total', 'total'],
                ].map(([name, key]) => (
                  <TableRow key={key} hover tabIndex={-1}>
                    <StyledTableCell align="left">
                      <strong>{name}</strong>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {funnelReport[key].OPEN_SIGNUP_LINK}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {funnelReport[key].CONSUMER_CREATED}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {funnelReport[key].ACCOUNT_LINK_COMPLETED}
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Card.Body>
    </Card>
  );
}

export default DashboardFunnel;
